import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/announcements'
import { Collapse } from 'reactstrap'
import Icon from '@/components/Icon'
import Name from '@/components/Name'
import { localized } from '@/decorators/localized'

@localized()
class Announcements extends React.Component {
  componentDidMount () {
    this.props.getAnnouncements()
  }
  renderAnnouncement (announcement, index) {
    return (
      <Collapse isOpen={announcement.isOpen} key={index}>
        <div className='dashboard-message'>
          <div>
            {/* CMS TEXT HERE */}
            <Name data={{ name: announcement.text, latinName: announcement.latinText }} isHtml />
          </div>
          <button onClick={() => this.props.closeAnnouncement(announcement.id)} className='close'><Icon name='x' /></button>
        </div>
      </Collapse>
    )
  }
  render () {
    const { announcements, localize } = this.props
    const closedCount = announcements.announcements.filter(x => !x.isOpen).length
    const showReopenBtn = closedCount > 0
    return (
      <React.Fragment>
        <div className={showReopenBtn ? 'col-11' : 'col-12'} key={announcements.announcementsKey}>
          {announcements.announcements.map((a, index) => this.renderAnnouncement(a, index))}
        </div>
        {showReopenBtn && (
          <div className='col-1 text-right'>
            <button className='announcments-button btn btn-primary' title={localize('Announcements.ShowHidden')} onClick={() => this.props.reopenAnnouncements()}><i className='bx bxs-flag-alt' /> ({closedCount})</button>
          </div>
        )}

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  announcements: state.announcements,
  ...ownProps
})

const mapDispatchToProps = {
  getAnnouncements: actionCreators.getAnnouncements,
  closeAnnouncement: actionCreators.closeAnnouncement,
  reopenAnnouncements: actionCreators.reopenAnnouncements
}

export default connect(mapStateToProps, mapDispatchToProps)(Announcements)



// WEBPACK FOOTER //
// ./src/components/dashboard/announcements.js